export default "__VITE_ASSET__U9_LWRQj__"